import translationKeys from '@translationKeys'

import { ShortlistSortProfileValue } from '@modules/shortlist/types'

import { ManageTableConfigProps } from '../../types'

export const tableColumnsConfig: ManageTableConfigProps[] = [
  {
    fieldName: 'profileTitle',
    isEnabled: true,
    columnTitle: translationKeys.UPDATES_TABLE_HEADER_ITEM,
    restCellProps: { $cellWidth: 210, $fixedWidth: true, $nowrap: true },
    isSortable: false,
  },
  {
    fieldName: 'profileCreatedDate',
    isEnabled: true,
    columnTitle: translationKeys.MANAGE_ALERTS_HEADER_ALERT_ADDED,
    restCellProps: { $cellWidth: 130, $fixedWidth: true },
    isSortable: false,
  },
  {
    fieldName: 'profileUpdatedDate',
    isEnabled: true,
    columnTitle: translationKeys.UPDATES_TABLE_HEADER_LAST_UPDATED,
    restCellProps: { $cellWidth: 130, $fixedWidth: true },
    isSortable: false,
  },
  {
    fieldName: 'frequency',
    isEnabled: true,
    columnTitle: translationKeys.MANAGE_ALERTS_HEADER_FREQUENCY,
    restCellProps: { $cellWidth: 145, $fixedWidth: true },
    isSortable: false,
  },
]

export const MAP_FIELDS_TO_SORT_OPTION_VALUES: Record<string, ShortlistSortProfileValue[]> = {
  profileTitle: [
    ShortlistSortProfileValue.PROFILE_TITLE_TYPE,
    ShortlistSortProfileValue.PROFILE_TITLE_ASC,
    ShortlistSortProfileValue.PROFILE_TITLE_DESC,
  ],
  profileCreatedDate: [
    ShortlistSortProfileValue.ALERT_DATE_ADDED_DESCENDING,
    ShortlistSortProfileValue.ALERT_DATE_ADDED_ASCENDING,
  ],
  profileUpdatedDate: [
    ShortlistSortProfileValue.ALERT_DATE_UPDATE_DESCENDING,
    ShortlistSortProfileValue.ALERT_DATE_UPDATE_ASCENDING,
  ],
  frequency: [ShortlistSortProfileValue.ALERT_FREQUENCY],
}

export const MAP_SORT_POPOVER_TITLE = {
  profileTitle: translationKeys.ALERT_SORT_BY_PROFILE_TITLE,
  profileCreatedDate: translationKeys.ALERT_SORT_BY_PROFILE_DATE_ADDED,
  profileUpdatedDate: translationKeys.ALERT_SORT_BY_PROFILE_DATE_UPDATED,
  frequency: translationKeys.ALERT_SORT_BY_FREQUENCY,
}
